import React from "react";
import ButtonArrow from "../components/ButtonArrow";
import { useState } from "react";
import { useEffect } from "react";
import GastronomicVenue from "../components/GastronomicVenue";
import axios from "axios";
import { axiosConfig } from "../Helpers/AxiosRequest";
import CarouselComponent from "../components/CarouselComponent";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { API_URL } from "../Helpers/api";
import shuffleArray from "../Helpers/ShuffleArray";
import { Helmet } from "react-helmet";
import gastronomyImg from "../Images/gastronomy.jpg";

const Gastronomy = () => {
  const [gastronomy, setGastronomy] = useState();

  useEffect(() => {
    axios(axiosConfig("GET", `${API_URL}/advertising/get-active-adds/gastronomic`, null, true))
      .then((res) => {
        if (res.data.success) {
          const shuffledAdds = shuffleArray(res.data.adds);
          setGastronomy(shuffledAdds);
        } else {
          console.warn("No grastronomy adds found");
        }
      })
      .catch((err) => console.error(err.message));
  }, []);

  return (
    <main className="z-2 postiion-relative">
      <Helmet>
        <title>Gastronomía de Bella Unión – Cocina Típica y Sabores Locales</title>
        <meta
          name="description"
          content="Sabores auténticos de Bella Unión: disfruta de la gastronomía local con platos tradicionales y experiencias culinarias inolvidables."
        />
        <meta
          name="keywords"
          content="gastronomía Bella Unión, cocina típica Uruguay, platos regionales Bella Unión, sabores locales, restaurantes Bella Unión"
        />
        <link rel="canonical" href="https://bellaunion.uy/gastronomia" />
        <meta property="og:title" content="Gastronomía de Bella Unión – Cocina Típica y Sabores Locales" />
        <meta
          property="og:description"
          content="Sabores auténticos de Bella Unión: disfruta de la gastronomía local con platos tradicionales y experiencias culinarias inolvidables."
        />
        <meta property="og:url" content="https://bellaunion.uy/gastronomia" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={gastronomyImg} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Gastronomía de Bella Unión – Cocina Típica y Sabores Locales" />
        <meta
          name="twitter:description"
          content="Sabores auténticos de Bella Unión: disfruta de la gastronomía local con platos tradicionales y experiencias culinarias inolvidables."
        />
        <meta name="twitter:image" content={gastronomyImg} />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <CarouselComponent />
      <div
        className="position-absolute top-0 w-100 d-flex flex-column z-3 filter-dark"
        style={{ height: "100vh" }}
      >
        <h1 className="text-center text-light mt-auto">Gastronomía</h1>
        <div className="mb-auto text-center mt-5">
          <ButtonArrow />
        </div>
      </div>
      <div className="bg-light" id="main-container" style={{ marginTop: "100vh" }}>
        <div className="container pb-5">
          <div className="">
            <div className="container">
              <h2 className="text-center pt-5">Gastronomía</h2>
              {gastronomy?.length > 0 ? (
                <>
                  <div className="row g-3 d-flex align-items-center mb-3">
                    {gastronomy.map((venue, i) => (
                      <GastronomicVenue data={venue} key={venue._id} />
                    ))}
                  </div>
                </>
              ) : (
                <p className="fs-2 fw-light text-center">No se encontraron locales gastronómicos</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Gastronomy;
